import type { NodeFocusRequest } from 'features/knowledgeDocumentViewer/graph/NodeFocusRequestContext'
import type { LotoPanelState } from 'features/knowledgeDocumentViewer/types'

import type { LotoOtherPage } from './lotoIsolationPoints'
import type { LotoPageTarget } from './lotoPageLookups'

export type LotoTabUpdate = {
  pageNumber?: number
  selectedBoxIds?: string[]
  lotoPanel?: LotoPanelState
}

export type LotoTabOpen = LotoPageTarget & { lotoPanel: LotoPanelState }

export type LotoPageNavigation =
  | { kind: 'none' }
  | { kind: 'sameDocument'; update: LotoTabUpdate }
  | { kind: 'otherDocument'; tab: LotoTabOpen }

type LotoNavigationContext = {
  activeReportId: string | undefined
  systemDocumentId: string | undefined
  focusNode?: NodeFocusRequest
}

export function resolveLotoPageNavigation(
  {
    systemDocumentId,
    target,
  }: Pick<LotoOtherPage, 'systemDocumentId' | 'target'>,
  context: LotoNavigationContext
): LotoPageNavigation {
  const { activeReportId, focusNode } = context
  if (!target || !activeReportId) return { kind: 'none' }
  const lotoPanel = { activeReportId, focusNode }
  if (systemDocumentId === context.systemDocumentId)
    return {
      kind: 'sameDocument',
      update: { pageNumber: target.pageNumber, selectedBoxIds: [], lotoPanel },
    }
  return { kind: 'otherDocument', tab: { ...target, lotoPanel } }
}
